import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export function getMatchHubOverviewStyles(theme: Theme) {
  return StyleSheet.create({
    oddsRow: {
      flexDirection: 'row',
      gap: theme.spacing.sm,
    },
    /** Design odds tile: dark inset tile, bordered, value in amber. */
    oddsCell: {
      flex: 1,
      backgroundColor: theme.background.inset,
      borderRadius: theme.borderRadius.md,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[300],
      paddingVertical: theme.spacing.md,
      alignItems: 'center',
      gap: 3,
      minHeight: 52,
      justifyContent: 'center',
    },
    oddsLabel: {
      ...theme.typography.caption,
      color: theme.gray[600],
    },
    oddsValue: {
      fontSize: 16,
      fontWeight: '800',
      color: theme.accentDark,
    },
    formRow: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: theme.spacing.md,
    },
    formTeamBlock: {
      flexDirection: 'row',
      alignItems: 'center',
      flex: 1,
    },
    formTeamName: {
      ...theme.typography.bodySmall,
      color: theme.gray[800],
      width: 72,
      marginRight: theme.spacing.sm,
    },
    formPills: {
      flexDirection: 'row',
      gap: 6,
    },
    formEmptyText: {
      ...theme.typography.bodySmall,
      color: theme.gray[500],
    },
    formPill: {
      width: 28,
      height: 28,
      borderRadius: 6,
      alignItems: 'center',
      justifyContent: 'center',
    },
    formPillWin: {
      backgroundColor: theme.success,
    },
    formPillDraw: {
      backgroundColor: theme.gray[400],
    },
    formPillLoss: {
      backgroundColor: theme.error,
    },
    formPillText: {
      fontSize: 12,
      fontWeight: '700',
      color: theme.white,
    },
  });
}
